import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from 'components/AppIcon';
import BreadcrumbNavigation from 'components/ui/BreadcrumbNavigation';
import BookingsTable from './components/BookingsTable';
import BookingToolbar from './components/BookingToolbar';
import BookingModal from './components/BookingModal';
import BookingDetailsModal from './components/BookingDetailsModal';
import { retrieveBookings, cancelBooking } from 'services/bookingService';
import { useSelector } from 'react-redux';
import ConfirmationModal from 'components/ui/ConfirmationModal';
import { toast } from 'react-toastify';
import CollectionModal from './components/CollectionModal';
import PaymentModal from './components/PaymentModal';
import { getCurrentDateString } from 'utils/DateUtil';

const BookingManagement = () => {
  const navigate = useNavigate();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState('add');
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [selectedBookingForDetails, setSelectedBookingForDetails] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [roleFilter, setRoleFilter] = useState('all');
  const [statusFilter, setStatusFilter] = useState(4);
  const [selectedBookingList, setSelectedBookingList] = useState([]);
  const [bookingDates, setToBookingDates] = useState({from:'', to:''});
  const selectedBusiness = useSelector((state) => state?.business.selectedBusiness);
  const [displayConfirmationModal, setDisplayConfirmationModal] = useState(false);  
  const [bookingId, setBookingId] = useState(null);
  const [bookingList, setbookingList] = useState([]);
  const [collectionModalOpen, setCollectionModalOpen] = useState(false);
  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  


  const resetBookingDates = async () => {
    const currentDate = getCurrentDateString();
    var localStorageData = localStorage.getItem('bookingDateFilters');
    localStorageData = localStorageData ? JSON.parse(localStorageData) : {
      from: currentDate,
      to: currentDate
    };
    setToBookingDates(localStorageData);
    localStorage.setItem('bookingDateFilters', JSON.stringify(localStorageData));

    getBookings(localStorageData.from, localStorageData.to);
  }

  const getBookings = async (from, to) => {
    if(!selectedBusiness?.businessId) return;

    const response = await retrieveBookings(selectedBusiness.businessId,from,to, statusFilter);
    if(response.success && response.data){
      setbookingList(response.data);
    }
  };


  // Check authentication
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (!token) {
      navigate('/login');
    }
    resetBookingDates();

    const storedStatusFilter = localStorage.getItem('bookingStatusFilter');
    setStatusFilter(storedStatusFilter ? parseInt(storedStatusFilter) : 4);
  }, [navigate]);

  // Filter staff members
  const filteredBooking = bookingList?.filter(booking => {
    const matchesSearch = booking?.name?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
                         booking?.email?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
                         booking?.employeeId?.toLowerCase()?.includes(searchTerm?.toLowerCase());
    const matchesStatus = statusFilter === 4 || booking?.status === statusFilter;
    
    return matchesSearch && matchesStatus;
    //return bookingList;
  });

  const handleAddBooking = () => {
    setModalMode('add');
    setSelectedBooking(null);
    setIsBookingModalOpen(true);
  };

  const handleEditBooking = (booking) => {
    setModalMode('edit');
    setSelectedBooking(booking);
    setIsBookingModalOpen(true);
  };

  const handleViewDetails = (booking) => {
    setSelectedBookingForDetails(booking);
    setIsDetailsModalOpen(true);
  };

  const handleCancelBooking = (booking) => {
    setBookingId(booking?.id);
    setDisplayConfirmationModal(true);
  };

  const handleSaveBooking = () => {
    //Fetch bookings
    getBookings(bookingDates.from, bookingDates.to);
  };

  const handleSelectBooking = (bookingId) => {
    setSelectedBookingList(prev => 
      prev?.includes(bookingId)
        ? prev?.filter(id => id !== staffId)
        : [...prev, bookingId]
    );
  };

  const handleSelectAll = () => {
    if (selectedBookingList?.length === filteredBooking?.length) {
      setSelectedBooking([]);
    } else {
      setSelectedBooking(filteredBooking?.map(staff => staff?.id));
    }
  };

  const handleBookingDetailsUpdate = (bookingId,status)=>{
    console.log('Booking details updated:', bookingId, status);
    setbookingList(prev => 
      prev?.map(b => 
        b?.id === bookingId
          ? { ...b, status: status }
          : b
      )
    );
    setIsDetailsModalOpen(false);
  }

  const handleBulkAction = (action) => {
    switch (action) {
      case 'activate':
        setbookingList(prev => 
          prev?.map(s => 
            selectedBookingList?.includes(s?.id) 
              ? { ...s, status: 'active' }
              : s
          )
        );
        break;
      case 'deactivate':
        setbookingList(prev => 
          prev?.map(s => 
            selectedBookingList?.includes(s?.id) 
              ? { ...s, status: 'inactive' }
              : s
          )
        );
        break;
      case 'delete':
        if (window.confirm(`Are you sure you want to delete ${selectedBookingList?.length} staff member(s)?`)) {
          setbookingList(prev => 
            prev?.filter(s => !selectedBookingList?.includes(s?.id))
          );
        }
        break;
    }
    setSelectedBookingList([]);
  };

  const user = {
    name: 'Admin User',
    email: 'admin@carwash.com',
    role: 'Administrator'
  };

  const applyDateFilter = (key, val) => {
    setToBookingDates({...bookingDates, [key]: val});

    if(key === 'from' && bookingDates?.to && val > bookingDates?.to){
      setToBookingDates(prev => ({...prev, to: val}));
    }

    //Store Date filters in storage
    var localStorageData = localStorage.getItem('bookingDateFilters');
    localStorageData = localStorageData ? JSON.parse(localStorageData) : {};
    localStorageData[key] = val;
    localStorage.setItem('bookingDateFilters', JSON.stringify(localStorageData));
  }

  const confirmCancelBooking = async () => {
    // Logic to cancel the booking goes here
    const response = await cancelBooking(selectedBusiness?.businessId, bookingId);
    if(response.success){
      toast.success(response.message || 'Booking cancelled successfully');
      // Refresh bookings
      getBookings();
    }
    else{
      toast.error(response.message || 'Failed to cancel booking');
    }
    setDisplayConfirmationModal(false);
  }

  const handleBookingCollection=(booking)=>{
    setSelectedBooking(booking);
    setCollectionModalOpen(true);
  }

  const handleBookingPayment=(booking)=>{
    setSelectedBooking(booking);
    setPaymentModalOpen(true);
  }

  const handleStatusChange = (val)=>{
    localStorage.setItem('bookingStatusFilter', val);
    setStatusFilter(val);
  }

  return (
    <>
      <div className="p-4 lg:p-6">
        {/* Page Header */}
        <div className="mb-6">
          <BreadcrumbNavigation />
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mt-4">
            <div>
              <h1 className="text-2xl lg:text-3xl font-bold text-foreground flex items-center">
                <Icon name="ChartLine" size={32} className="mr-3 text-primary" />
                Booking Management
              </h1>
              <p className="text-muted-foreground mt-1">
                Manage bookings
              </p>
            </div>
            
            {/* Quick Stats */}
            <div className="flex items-center space-x-6 text-sm">
              <div className="text-center">
                <div className="text-lg font-bold text-primary">
                  {bookingList?.filter(s => s?.status === 3)?.length}
                </div>
                <div className="text-muted-foreground">Completed</div>
              </div>
              <div className="text-center">
                <div className="text-lg font-bold text-warning">
                  {bookingList?.filter(s => s?.status === 1)?.length}
                </div>
                <div className="text-muted-foreground">In Progress</div>
              </div>
              <div className="text-center">
                <div className="text-lg font-bold text-warning">
                  {bookingList?.filter(s => s?.status === 0)?.length}
                </div>
                <div className="text-muted-foreground">Pending</div>
              </div>
              <div className="text-center">
                <div className="text-lg font-bold text-destructive">
                  {bookingList?.filter(s => s?.status === 2)?.length}
                </div>
                <div className="text-muted-foreground">Cancelled</div>
              </div>
            </div>
          </div>
        </div>

        {/* Content Layout */}
        <div className="flex flex-col xl:flex-row gap-6">
          {/* Main Content Area */}
          <div className="flex-1 space-y-6">
            {/* Toolbar */}
            <BookingToolbar
              searchTerm={searchTerm}
              onSearchChange={setSearchTerm}
              roleFilter={roleFilter}
              onRoleFilterChange={setRoleFilter}
              statusFilter={statusFilter}
              onStatusFilterChange={handleStatusChange}
              onAddStaff={handleAddBooking}
              selectedCount={selectedBookingList?.length}
              onBulkAction={handleBulkAction}
              totalCount={filteredBooking?.length}
              dateFilters={bookingDates}
              onDateFilterChange={applyDateFilter}
              refreshBookings={()=>getBookings(bookingDates.from, bookingDates.to)}
            />

            {/* Booking Table */}
            <BookingsTable
              bookingList={filteredBooking}
              onEdit={handleEditBooking}
              onViewDetails={handleViewDetails}
              onCancelBooking={handleCancelBooking}
              selectedBooking={selectedBookingList}
              onSelectBooking={handleSelectBooking}
              onSelectAll={handleSelectAll}
              isAllSelected={selectedBookingList?.length === filteredBooking?.length && filteredBooking?.length > 0}
              onCollection={handleBookingCollection}
              onPayment={handleBookingPayment}
            />
          </div>
        </div>
      </div>
      {/* Modals */}
      <ConfirmationModal
        open={displayConfirmationModal}
        title="Confirm Cancellation"
        description="Are you sure you want to cancel this booking? This action cannot be undone."
        confirmationLabel="Yes, Cancel Booking"
        cancellationLabel="No, Keep Booking"
        onConfirmation={() => confirmCancelBooking()}
        onCancellation={() => setDisplayConfirmationModal(false)}
      />
      <BookingModal
        isOpen={isBookingModalOpen}
        onClose={() => setIsBookingModalOpen(false)}
        booking={selectedBooking}
        onSave={handleSaveBooking}
        mode={modalMode}
      />
      <BookingDetailsModal
        isOpen={isDetailsModalOpen}
        onClose={handleBookingDetailsUpdate}
        booking={selectedBookingForDetails}
        onEdit={handleEditBooking}
        onCollection={handleBookingCollection}
      />

      <CollectionModal
        open={collectionModalOpen}
        onCancellation={() => {
          setSelectedBooking(null);
          setCollectionModalOpen(false);
        }}
        onSuccessfulCollection={(bookingId)=>{
          setbookingList(prev => 
            prev?.map(b => 
              b?.id === bookingId
                ? { ...b, collected: true }
                : b
            )
          );
          setCollectionModalOpen(false);
        }}
        booking={selectedBooking}
      />

      <PaymentModal
        open={paymentModalOpen}
        onCancellation={() => {
          setSelectedBooking(null);
          setPaymentModalOpen(false);
        }}
        onSuccessfullPayment={(bookingId)=>{
          setbookingList(prev => 
            prev?.map(b => 
              b?.id === bookingId
                ? { ...b, totalAmountSettled: true }
                : b
            )
          );
          setPaymentModalOpen(false);
        }}
        booking={selectedBooking}
      />
    </>
  );
};

export default BookingManagement;